import redirect from 'nextjs-redirect';

export default redirect;
